<ul class="pcg-search-filter__list">
    <li *ngFor="let category of aggregation.subcategories" class="pcg-search-filter__item">
        <div *ngIf="category.subcategories.length" [ngClass]="{'expanded' : category.expanded}" class="pcg-filter-collapsible pcg-contrast-filter-collapsible">
            <button class="pcg-filter-collapsible__btn" [ngClass]="{ 'active': hasFilterInGroup(category) }" (click)="onCategoriesGroupItemClicked($event, category)" [attr.aria-expanded]="category.expanded">
                <span class="pcg-filter-collapsible__label">{{category.title}}</span>
                <span *ngIf="hasFilterInGroup(category) && !category.expanded" class="pcg-filter-collapsible__filters">{{ selectedFiltersInGroup(category) }}</span>
            </button>
            <ul class="pcg-filter-collapsible__content">
                <ng-container *ngFor="let subcategory of category.subcategories">
                    <ng-container *ngIf="!subcategory.subcategories.length">
                        <li class="pcg-filter-collapsible__item">
                            <label class="pcg-custom-checkbox pcg-contrast-custom-checkbox">
                                <input type="checkbox" value="{{subcategory.value}}" (click)="onCategoryItemClicked($event)" [checked]="subcategory.selected">
                                <span class="pcg-custom-checkbox__text">{{subcategory.title}}</span>
                            </label>
                        </li>
                    </ng-container>

                    <ng-container *ngIf="subcategory.subcategories.length">
                        <div class="pcg-filter-collapsible pcg-contrast-filter-collapsible" [ngClass]="{'expanded' : subcategory.expanded}">
                            <button class="pcg-filter-collapsible__btn" (click)="onCategoriesGroupItemClicked($event, subcategory)"><span class="pcg-filter-collapsible__label">{{subcategory.title}}</span></button>
                            <ul class="pcg-filter-collapsible__content">
                                <ng-container *ngFor="let subcategory2 of subcategory.subcategories">
                                    <ng-container *ngIf="!subcategory2.subcategories.length">
                                        <li class="pcg-filter-collapsible__item">
                                            <label class="pcg-custom-checkbox pcg-contrast-custom-checkbox">
                                                <input type="checkbox" value="{{subcategory2.value}}" (click)="onCategoryItemClicked($event)" [checked]="subcategory2.selected">
                                                <span class="pcg-custom-checkbox__text">{{subcategory2.title}}</span>
                                            </label>
                                        </li>
                                    </ng-container>

                                    <ng-container *ngIf="subcategory2.subcategories.length">
                                        <div class="pcg-filter-collapsible pcg-contrast-filter-collapsible" [ngClass]="{'expanded' : subcategory2.expanded}">
                                            <button class="pcg-filter-collapsible__btn" (click)="onCategoriesGroupItemClicked($event, subcategory2)"><span class="pcg-filter-collapsible__label">{{subcategory2.title}}</span></button>
                                            <ul class="pcg-filter-collapsible__content">
                                                <ng-container *ngFor="let subcategory3 of subcategory2.subcategories">
                                                    <li class="pcg-filter-collapsible__item">
                                                        <label class="pcg-custom-checkbox pcg-contrast-custom-checkbox">
                                                            <input type="checkbox" value="{{subcategory3.value}}" (click)="onCategoryItemClicked($event)" [checked]="subcategory3.selected">
                                                            <span class="pcg-custom-checkbox__text">{{subcategory3.title}}</span>
                                                        </label>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </div>
                    </ng-container>

                </ng-container>
            </ul>
        </div>
        <div *ngIf="!category.subcategories.length" class="pcg-category__checkbox-wrapper">
            <label class="pcg-custom-checkbox pcg-contrast-custom-checkbox">
                <input type="checkbox" (click)="onCategoryItemClicked($event)" value="{{category.value}}" [checked]="category.selected">
                <span class="pcg-custom-checkbox__text">{{category.title}}</span>
            </label>
        </div>
    </li>
</ul>


